import React, { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

interface MapProps {
  breeders?: Array<{
    id: number;
    name: string;
    location: string;
    lat: number;
    lng: number;
  }>;
  center?: [number, number];
  zoom?: number;
  height?: string;
  listingTitle?: string;
  listingLocation?: string;
}

const Map = ({
  breeders,
  center = [0, 20],
  zoom = 2,
  height = "400px",
  listingTitle,
  listingLocation,
}: MapProps) => {
  const mapContainer = useRef(null);
  const map = useRef(null);

  // Use dummy data if no breeders provided
  const dummyBreeders = [
    {
      id: 1,
      name: "Smith Ranch",
      location: "Texas",
      lat: 32.7767,
      lng: -96.797,
    },
    {
      id: 2,
      name: "Johnson Farm",
      location: "California",
      lat: 34.0522,
      lng: -118.2437,
    },
    {
      id: 3,
      name: "Williams Cattle Co",
      location: "Montana",
      lat: 46.8059,
      lng: -110.3626,
    },
  ];

  const breedersToShow = breeders || dummyBreeders;

  useEffect(() => {
    if (map.current) return; // initialize map only once

    // Public token
    mapboxgl.accessToken =
      "pk.eyJ1IjoiZGF2aWRrciIsImEiOiJjbWNiMzFzeW8wYXVpMmpzZjkyOW1yMG40In0.8POarDwFjvrA20yC_OJryA"; // Replace with your pk.* token

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: center,
      zoom: zoom,
    });

    map.current.addControl(new mapboxgl.NavigationControl(), "top-right");

    // Add markers
    breedersToShow.forEach((breeder) => {
      const el = document.createElement("div");
      el.className = "marker";
      el.style.width = "20px";
      el.style.height = "20px";
      el.style.borderRadius = "50%";
      el.style.backgroundColor = "#22c55e";
      el.style.border = "2px solid white";
      el.style.cursor = "pointer";

      // Use listing info if provided, otherwise use breeder info
      const popupTitle = listingTitle || breeder.name;
      const popupLocation = listingLocation || breeder.location;

      const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
        `<div style="padding: 8px;">
          <h3 style="margin: 0; font-weight: bold;">${popupTitle}</h3>
          <p style="margin: 4px 0 0 0; color: #666;">${popupLocation}</p>
        </div>`
      );

      new mapboxgl.Marker(el)
        .setLngLat([breeder.lng, breeder.lat])
        .setPopup(popup)
        .addTo(map.current);
    });
  }, []);

  useEffect(() => {
    return () => map.current?.remove();
  }, []);

  return (
    <div style={{ height }} className="relative rounded-lg overflow-hidden">
      <div ref={mapContainer} className="w-full h-full" />
    </div>
  );
};

export default Map;
